import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { max } from '../utils/breakpoints';

interface ThemeToggleButtonProps {
  currentTheme: string;
  onThemeToggle: () => void;
}

const FloatingButton = styled.button<{ theme: any; isAnimating: boolean }>`
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background: ${(props) => props.theme.colors.primary};
  color: ${(props) => props.theme.colors.white};
  border: 3px solid ${(props) => props.theme.colors.white};
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
  z-index: 9999;
  transition: all 0.2s ease-in-out;
  user-select: none;

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 8px 12px rgba(0, 0, 0, 0.25);
    border-color: ${(props) => props.theme.colors.extraLight || props.theme.colors.white};
  }

  &:active {
    transform: scale(0.95);
    transition: all 0.1s ease-in-out;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px ${(props) => props.theme.colors.primary}40;
  }

  ${max.md} {
    bottom: 20px;
    right: 20px;
    width: 62px;
    height: 62px;
    font-size: 10px;
  }

  ${max.sm} {
    bottom: 15px;
    right: 15px;
    width: 55px;
    height: 55px;
    font-size: 8px;
  }
`;

const ThemeToggleButton: React.FC<ThemeToggleButtonProps> = ({ currentTheme, onThemeToggle }) => {
  const [isAnimating, setIsAnimating] = useState(false);

  // Trigger animation when theme changes
  useEffect(() => {
    setIsAnimating(true);
    const timer = setTimeout(() => setIsAnimating(false), 600);
    return () => clearTimeout(timer);
  }, [currentTheme]);

  return (
    <FloatingButton
      onClick={onThemeToggle}
      title={`Switch to ${currentTheme === 'Loop' ? 'Utilita' : 'Loop'} theme`}
      aria-label={`Switch to ${currentTheme === 'Loop' ? 'Utilita' : 'Loop'} theme`}
      isAnimating={isAnimating}
    >
      {currentTheme === 'Loop' ? 'Press for Utilita' : 'Press for Loop'}
    </FloatingButton>
  );
};

export default ThemeToggleButton;
